var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.287 4.449l5.398-2.314a.8.8 0 01.63 0l5.398 2.314a.6.6 0 010 1.102L8.315 7.865a.8.8 0 01-.63 0L2.287 5.55a.6.6 0 010-1.102z",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5l-2.088.696a.6.6 0 00-.068 1.11l5.312 2.53a.8.8 0 00.688 0l5.312-2.53a.6.6 0 00-.069-1.11L11.5 6.5",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5l-2.088.696a.6.6 0 00-.068 1.11l5.312 2.53a.8.8 0 00.688 0l5.312-2.53a.6.6 0 00-.069-1.11L11.5 9.5",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/personal_group.a130b790.svg";
export { SvgPersonalGroup as ReactComponent };